import { Toast as AntToast } from 'antd-mobile';
import { useEffect } from 'react';
import { useStore } from '../store';

export function Toast() {
    const toast = useStore((s) => s.toast);

    useEffect(() => {
        if (toast.visible && toast.message) {
            AntToast.show({
                content: toast.message,
                duration: 2000,
            });
        }
    }, [toast.visible, toast.message]);

    return null;
}

export default Toast;
